"use client";
import React from "react";
import dynamic from "next/dynamic";
import rsLoadingAnimation from "@/types/animations/rsLoading.json";


const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false,
});

export default function LoadingAnimation() {
  return (
    <div className="fixed inset-0 bg-[#f7f7f7] flex items-center justify-center z-[9999] w-screen h-screen overflow-hidden">
      <div className="size-96">
        <Lottie
          animationData={rsLoadingAnimation}
          loop={true}
          autoplay={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
}
